import ApiConstants from "../../Constants/ApiConstant";
import { apiGet } from "../../Services/ApiService";

export const getPageDeatailsAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(`${ApiConstants.pageUrl}?page_slug=${data}`, data)
        .then((response) => {
          callBack && callBack(response);
        })
        .catch((err) => {
          console.log("get Page api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("get Page api err", err);
      throw err;
    }
  };
};
